import { useRequiredContext } from "@suse-o11y/use-required-context";

import type { MonitorStatusDrawerContextValue } from "./_context";
import { MonitorStatusDrawerContext } from "./_context";

export type { MonitorStatusDrawerContextValue } from "./_context";

export const useMonitorStatusDrawerContext = (): MonitorStatusDrawerContextValue =>
	useRequiredContext(MonitorStatusDrawerContext, { providerName: "MonitorStatusDrawerProvider" });
